module.exports = __webpack_public_path__ + "media/styles/images/svg/pen-white-b1e7bdfcfbc290554c40e352309cf3b8.svg";